import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pick-for-move",
  "use": "pick-for-move-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"pick-for-move\"><path d=\"M3 5v1h2V5h1V3H5c-1.103 0-2 .896-2 2zM11 3H8v2h3V3zM16 3h-3v2h3V3zM19 3h-1v2h1v1h2V5a2 2 0 00-2-2zM5 18H3v1c0 1.102.897 2 2 2h1v-2H5v-1zM11 19H8v2h3v-2zM16 19h-3v2h3v-2zM19 19h-1v2h1c1.104 0 2-.898 2-2v-1h-2v1zM5 13H3v3h2v-3zM5 8H3v3h2V8zM21 13h-2v3h2v-3zM21 8h-2v3h2V8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol